<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search by name, designation, or employee ID"
    [(searchTerm)]="searchTerm"
    (searchChange)="onSearchChange($event)"
    iconSize="small"
  >
  </app-searchbar>
  <div class="filter-container">
    <app-action-button
      buttonText="Filter"
      iconSrc="assets/images/package/adjustments.svg"
      [showCount]="hasActiveFilters"
      [count]="getActiveFilterCount()"
      (buttonClick)="openFilterModal()"
    >
    </app-action-button>
  </div>
</div>

<!-- Employees Table -->
<div *ngIf="!loading && paginatedEmployees.length > 0" class="table-section">
  <div class="table-container">
    <div class="table-scroll-wrapper" #employeeTableScrollWrapper>
      <table class="employees-table">
        <colgroup>
          <col style="width: 18%" />
          <col style="width: 10%" />
          <col style="width: 14%" />
          <col style="width: 14%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 6%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
        </colgroup>
        <thead>
          <tr>
            <th>Employee</th>
            <th>Role</th>
            <th>Attendance</th>
            <th>Contact</th>
            <th>Opening Balance</th>
            <th>Location</th>
            <th>Orders</th>
            <th>Appointments</th>
            <th>Employment Status</th>
            <th>Permission</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let employee of paginatedEmployees; trackBy: trackByEmployeeId; let i = index"
            class="employee-row"
            [attr.data-index]="i"
          >
            <td>
              <div class="employee-info">
                <div class="employee-avatar">
                  <img
                    *ngIf="employee.picture_url"
                    [src]="employee.picture_url"
                    [alt]="getEmployeeDisplayData(employee.id, 'fullName')"
                    class="avatar-image"
                  />
                  <span *ngIf="!employee.picture_url" class="avatar-initials">
                    {{ getEmployeeDisplayData(employee.id, 'initials') }}
                  </span>
                </div>
                <div class="employee-details">
                  <div
                    class="employee-name clickable-name"
                    (click)="onViewEmployeeProfile(employee)"
                  >
                    {{ getEmployeeDisplayData(employee.id, 'fullName') }}
                  </div>
                  <div class="employee-id">
                    {{ getEmployeeDisplayData(employee.id, 'employeeId') }}
                  </div>
                </div>
              </div>
            </td>
            <td>{{ employee.designation }}</td>
            <td>
              <ng-container *ngIf="isShopAdminRow(employee); else staffAttendanceCell">
                —
              </ng-container>
              <ng-template #staffAttendanceCell>
                <div class="attendance-cell">
                  <ng-container
                    *ngIf="
                      getAttendanceStatus(employee) as attendanceStatus;
                      else inactiveAttendance
                    "
                  >
                    <span
                      class="attendance-status-badge"
                      [ngClass]="getAttendanceStatusClass(attendanceStatus)"
                    >
                      <span class="attendance-dot" aria-hidden="true"></span>
                      {{ getAttendanceStatusLabel(attendanceStatus) }}
                    </span>
                  </ng-container>
                  <ng-template #inactiveAttendance>
                    <span>—</span>
                  </ng-template>
                  <span class="attendance-divider" aria-hidden="true"></span>
                  <button
                    type="button"
                    class="attendance-link"
                    (click)="onViewAttendance(employee)"
                  >
                    View
                  </button>
                </div>
              </ng-template>
            </td>
            <td>
              <div class="contact-info">
                <div class="contact-email">{{ employee.email }}</div>
                <div class="contact-phone">
                  {{ getEmployeeDisplayData(employee.id, 'phoneNumber') }}
                </div>
              </div>
            </td>
            <td>${{ employee.default_opening_balance || '0' }}</td>
            <td>{{ isShopAdminRow(employee) ? '—' : employee.branch }}</td>
            <td>{{ getEmployeeDisplayData(employee.id, 'orderNumber') }}</td>
            <td>{{ employee.total_appointments || '0' }}</td>
            <td>
              <span class="employment-status" [class.employment-inactive]="!employee.emp_status">
                {{ employee.emp_status ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>
              <span class="permission-pill" [ngClass]="permissionPillClass(employee.role)">
                {{ formatPermissionLabel(employee.role) }}
              </span>
            </td>
            <td>
              <div
                class="actions-cell"
                (click)="$event.stopPropagation()"
                *ngIf="showRowActions(employee)"
              >
                <button class="actions-button" (click)="toggleActionsDropdown($event, employee.id)">
                  <ng-container *ngTemplateOutlet="threeDotsIcon"></ng-container>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="loading-container">
  <app-loading-table-shimmer
    [columns]="shimmerColumns"
    [rows]="5"
    [showHeader]="false"
  ></app-loading-table-shimmer>
</div>

<!-- Empty State - No Search/Filter Results -->
<div
  *ngIf="
    !loading &&
    (searchTerm.trim() || hasActiveFilters) &&
    employees.length === 0 &&
    hasLoadedEmployeesOnce &&
    totalItems === 0
  "
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No results found"
    description="No employees found matching your search or filter criteria. Try adjusting your search or filters."
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Empty State - No Employees -->
<div
  *ngIf="
    !loading &&
    !searchTerm.trim() &&
    !hasActiveFilters &&
    employees.length === 0 &&
    hasLoadedEmployeesOnce &&
    totalItems === 0
  "
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No employees to show"
    description="Start adding employees to track all employee details here."
    [actionText]="'Add Employee'"
    [showAction]="true"
    (actionClicked)="onEmptyAddEmployeeClick()"
  >
  </app-empty-result>
</div>

<!-- Pagination -->
<div class="pagination-wrapper" *ngIf="!loading && employees.length > 0 && totalItems > 0">
  <app-pagination-bar
    [paginationData]="paginationData"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  >
  </app-pagination-bar>
</div>

<!-- Modals -->
<app-add-employee-modal
  [isVisible]="showAddModal"
  (closeModal)="onCloseAddEmployeeModal()"
  (saveEmployee)="onSaveEmployee($event)"
>
</app-add-employee-modal>

<app-add-employee-modal
  [isVisible]="showEditEmployeeModal"
  [employee]="employeeToEdit"
  (closeModal)="onCloseEditEmployeeModal()"
  (saveEmployee)="onSaveEditEmployee($event)"
>
</app-add-employee-modal>

<app-employee-profile-modal
  [isVisible]="showEmployeeProfileModal"
  [employee]="selectedEmployee"
  (closeModal)="onCloseEmployeeProfileModal()"
>
</app-employee-profile-modal>

<app-attendance-records-modal
  [isVisible]="showAttendanceRecordsModal"
  [employee]="selectedEmployeeForAttendance"
  (closeModal)="onCloseAttendanceRecordsModal()"
>
</app-attendance-records-modal>

<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  [primaryButtonText]="'Apply Filters'"
  [secondaryButtonText]="'Clear Filters'"
  [categories]="filterCategories"
  (close)="closeFilterModal()"
  (apply)="onFilterApply($event)"
>
</app-filter-modal>

<app-confirmation-modal
  [isVisible]="showEmployeeDeleteModal"
  [data]="employeeDeleteModalData"
  (cancel)="onEmployeeDeleteCancel()"
  (confirm)="onEmployeeDeleteConfirm()"
>
</app-confirmation-modal>

<app-confirmation-modal
  [isVisible]="showRemoveCoAdminModal"
  [data]="removeCoAdminModalData"
  (cancel)="onRemoveCoAdminCancel()"
  (confirm)="onRemoveCoAdminConfirm()"
>
</app-confirmation-modal>

<!-- Global Employee Actions Dropdown -->
<div
  class="actions-dropdown-menu"
  *ngIf="activeActionsDropdown && selectedEmployeeForDropdown"
  [id]="'dropdown-' + activeActionsDropdown"
>
  <ng-container *ngIf="!isShopAdminRow(selectedEmployeeForDropdown); else shopAdminActions">
    <div class="dropdown-item" (click)="onEditEmployee(selectedEmployeeForDropdown!)">
      <div class="dropdown-content">
        <span class="dropdown-text">Edit</span>
        <img
          src="/assets/images/pencil.svg"
          alt="Edit"
          class="dropdown-icon"
          width="14"
          height="14"
        />
      </div>
    </div>
    <div class="dropdown-item delete-item" (click)="onDeleteEmployee(selectedEmployeeForDropdown!)">
      <div class="dropdown-content">
        <span class="dropdown-text">Delete</span>
        <img
          src="/assets/images/trash.svg"
          alt="Delete"
          class="dropdown-icon"
          width="14"
          height="14"
        />
      </div>
    </div>
  </ng-container>
  <ng-template #shopAdminActions>
    <div class="dropdown-item" (click)="onEditEmployee(selectedEmployeeForDropdown!)">
      <div class="dropdown-content">
        <span class="dropdown-text">Edit</span>
        <img
          src="/assets/images/pencil.svg"
          alt="Edit"
          class="dropdown-icon"
          width="14"
          height="14"
        />
      </div>
    </div>
    <div
      class="dropdown-item delete-item"
      *ngIf="canRemoveCompanyAdmin(selectedEmployeeForDropdown)"
      (click)="onRemoveCompanyAdmin(selectedEmployeeForDropdown!)"
    >
      <div class="dropdown-content">
        <span class="dropdown-text">Remove Admin</span>
        <img
          src="/assets/images/trash.svg"
          alt="Remove"
          class="dropdown-icon"
          width="14"
          height="14"
        />
      </div>
    </div>
  </ng-template>
</div>

<!-- Three-dot icon template -->
<ng-template #threeDotsIcon>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 8.66667C8.36819 8.66667 8.66667 8.36819 8.66667 8C8.66667 7.63181 8.36819 7.33333 8 7.33333C7.63181 7.33333 7.33333 7.63181 7.33333 8C7.33333 8.36819 7.63181 8.66667 8 8.66667Z"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 4C8.36819 4 8.66667 3.70152 8.66667 3.33333C8.66667 2.96514 8.36819 2.66667 8 2.66667C7.63181 2.66667 7.33333 2.96514 7.33333 3.33333C7.33333 3.70152 7.63181 4 8 4Z"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 13.3333C8.36819 13.3333 8.66667 13.0349 8.66667 12.6667C8.66667 12.2985 8.36819 12 8 12C7.63181 12 7.33333 12.2985 7.33333 12.6667C7.33333 13.0349 7.63181 13.3333 8 13.3333Z"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>
